export enum education_status {
    "Titulado",
    "Egresado",
    "En Progreso",
    "Deserción",
}




